import { useNavigate, useSearchParams } from "react-router";
import useAppNavigation from "../../hooks/useAppNavigation";
import RegisterComponent from "./components/RegisterComponent";
import LandingPageWrapper from "./LandingPageWrapper";

export default function RegisterPage() {
  const navigate = useNavigate();
  const { navigateHome } = useAppNavigation();
  const [searchParams] = useSearchParams();

  const loginLink = "/sign-in";

  return (
    <LandingPageWrapper>
      <RegisterComponent
        onComplete={navigateHome}
        email={searchParams.get("email") ?? undefined}
        onClickLogin={() => navigate(loginLink)}
        sx={{
          px: { xs: 1, lg: 3 },
          borderRadius: 10,
          overflow: "hidden",
        }}
      />
    </LandingPageWrapper>
  );
}
